<template lang="html">
  <section class="sol_model">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <h3 class="card-text margin-b-md">Filters</h3>
              <hr>
              <b-row>
                <b-col class="col-lg-2 pt-2">ADM:</b-col>
                <b-select class="col-lg-4" v-model="filterObj.adm" id="selectedAdm"  v-on:change="isPostPriceConf=false">
                    <b-form-select-option :value="null">---</b-form-select-option>
                    <b-form-select-option :value="adm" v-if="admList" v-for="(adm,index) in admList">{{adm}}</b-form-select-option>
                </b-select>
                <b-col class="col-lg-2 pt-2 pt-2">Market:</b-col>
                <b-select class="col-lg-4" v-model="selectedCountry" id="selectedCountry" v-on:change="isPostPriceConf=false">
                      <b-form-select-option :value="null">---</b-form-select-option>
                      <b-form-select-option :value="country" v-if="filterObj.adm" v-for="(country,index) in getContryList">{{country.description}}</b-form-select-option>
                </b-select>
              </b-row>
              <br>
              <b-row>
                <b-col class="col-lg-2 pt-2">Model:</b-col>
                <b-select class="col-lg-4" v-model="filterObj.vetele"  id="selectedModelFilter"  v-on:change="isPostPriceConf=false">
                  <b-form-select-option :value="null">---</b-form-select-option>
                  <template v-for="models in getModelList" v-if="filterObj.adm && getModelList">
                    <optgroup :label="models.label">
                        <b-form-select-option v-for="(model,index) in models.items" :key="index" :value="model.value">{{model.label}}</b-form-select-option>
                      </optgroup>
                  </template>
                </b-select>
                <label class="col-lg-2 pt-2" for="visible">Show Only active</label>  
                <input type="checkbox" id="visible" value="visible" v-model="filterObj.showActive">           
              </b-row>
              <br>
              <b-row>
                <label class="col-lg-1 pt-2" for="showHq">Show Only HQ</label>  
                <input type="checkbox" id="showHq" value="showHq" v-model="filterObj.showHq"> 
              </b-row>
            </b-card>
          </b-collapse>
          <div class="col-lg-12 card-body row">
            <div class="col-lg-12">
              <h4 class="card-title">SOL Visibility:</h4>
            </div>
            <div class="col-lg-4">
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="6"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  aria-controls=""
                  class="col-lg-9"
                ></b-pagination>
               </div>              
               </div>
                <div class="col-lg-1">
                  <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-12">
                    <b-form-select-option value="5">5</b-form-select-option>
                    <b-form-select-option value="10">10</b-form-select-option>
                    <b-form-select-option value="15">15</b-form-select-option>
                    <b-form-select-option value="20">20</b-form-select-option>
                    <b-form-select-option value="50">50</b-form-select-option>
                    <b-form-select-option value="100">100</b-form-select-option>
                  </b-form-select>
            </div>
            <div class="col-lg-7">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="sortBy=''; refreshTable()"><i class="mdi mdi-refresh"></i>Apply</b-button>
                <b-button variant="primary mr-1" v-b-toggle.filters><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-new><i class="mdi mdi-plus"></i>New</b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-export><i class="mdi mdi-file-export"></i>Export</b-button>
                <b-button variant="primary" v-b-modal.modal-import><i class="mdi mdi-file-import"></i>Import</b-button>
              </span>
            </div>
            <b-table 
              id="table" 
              striped 
              hover 
              responsive 
              :items="items" 
              :fields="visibleFields"
              :per-page="perPage"
              :current-page="1"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              primary-key=""
              no-local-sorting
              no-provider-paging

            >
              <!-- Date Input -->
              <template v-slot:cell(visibleButton)="data" lang="html">
                 <b-row v-if="isHQUser">
                  <h4 class="panel-title" style="margin:auto;">                 
                    <b-button v-if="!data.item.visible && data.item.id.idSolMarket == 0" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Set Visible" @click="curItem=data.item; toggleElementStatus(data.item,true)">
                      <i  class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                    </b-button>
                    <b-button v-else-if="data.item.visible && data.item.id.idSolMarket == 0" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover title="Set Not Visible" @click="curItem=data.item; toggleElementStatus(data.item,false)">
                      <i class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                    </b-button>
                    <b-button v-else-if="!data.item.visible && data.item.id.idSolMarket != 0" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover disabled>
                      <i class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                    </b-button>
                    <b-button v-else-if="data.item.visible && data.item.id.idSolMarket != 0" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover disabled>
                      <i class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                    </b-button>
                  </h4>
                </b-row>
                <b-row v-else>
                  <b-button  v-if="!data.item.visible && data.item.id.idSolMarket != 0 && getVisibleSol(data.item.id.idSol)" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Set Visible" @click="curItem=data.item; toggleElementStatus(data.item,true)">
                    <i  class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                  </b-button>
                  <b-button v-else-if="!data.item.visible && data.item.id.idSolMarket != 0 && !getVisibleSol(data.item.id.idSol)" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover disabled>
                    <i  class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                  </b-button>
                  <b-button v-else-if="data.item.visible && data.item.id.idSolMarket != 0 && getVisibleSol(data.item.id.idSol)" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Set Not Visible" @click="curItem=data.item; toggleElementStatus(data.item,false)">
                    <i  class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                  </b-button>
                  <b-button v-else-if="data.item.visible && data.item.id.idSolMarket != 0 && !getVisibleSol(data.item.id.idSol)" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary" v-b-tooltip.hover title="Set Not Visible" @click="curItem=data.item; toggleElementStatus(data.item,false)">
                    <i  class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                  </b-button>
                  <b-button v-else-if="data.item.visible && data.item.id.idSolMarket == 0" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover disabled>
                    <i class="mdi mdi-check-outline btn-outline-success" style="display: block;"></i>
                  </b-button>
                   <b-button v-else-if="!data.item.visible && data.item.id.idSolMarket == 0" class="col-lg-5 p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="primary"  v-b-tooltip.hover disabled>
                      <i class="mdi mdi-close-outline btn-outline-secondary" style="display: block;"></i>
                    </b-button>
                </b-row>
              </template>
              <template v-slot:cell(updateDate)="data" lang="html">              
                {{customFormatter(data.item.updateDate)}}
              </template>
              <!-- A custom formatted column -->
              <template v-slot:cell(detail)="data" lang="html">
                <b-row>
                  <b-button class="col-lg-5 p-1 m-auto" style="min-width: 2.875rem;" size="sm" variant="primary" title="price configuration" v-if="data.item.idCountry" @click='goToPriceConf(data.item.vetele, data.item.idCountry)'>
                    <i class="mdi mdi-link-variant"></i>
                  </b-button>
                  <b-button class="col-lg-5 p-1 m-auto" style="min-width: 2.875rem;" size="sm" variant="primary" title="price configuration" v-else disabled>
                    <i class="mdi mdi-link-variant"></i>
                  </b-button>
                </b-row>
              </template>
            </b-table>
            <!-- Modal New -->
            <b-modal id="modal-new" :title="'New'" size="lg" header-bg-variant="primary" header-text-variant="light" centered @close="closeNewModal()" @hide="closeNewModal()">
              <b-container fluid>
                  <b-row>
                    <b-col class="col-lg-2 pt-2">ADM:</b-col>
                    <b-select class="col-lg-4" v-model="selectedNewAdm" id="selectedAdm">
                        <b-form-select-option :value="null">---</b-form-select-option>
                        <b-form-select-option :value="adm" v-if="admList" v-for="(adm,index) in admList">{{adm}}</b-form-select-option>
                    </b-select>
                    <b-col class="col-lg-2 pt-2">Market:</b-col>
                    <b-select class="col-lg-4" v-model="newItem.country" id="newCountry">
                          <b-form-select-option :value="null">---</b-form-select-option>
                          <b-form-select-option :value="country" v-if="selectedNewAdm" v-for="(country,index) in getContryListInsert">{{country.description}}</b-form-select-option>
                    </b-select>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col class="col-lg-2 pt-2">Model:</b-col>
                    <b-select class="col-lg-10" v-model="newItem.model.vetele" id="newModel">
                      <b-form-select-option :value="null">---</b-form-select-option>
                      <template v-for="models in getModelListInsert">
                        <optgroup :label="models.label">
                            <b-form-select-option v-for="(model,index) in models.items" :key="index" :value="model.value">{{model.label}}</b-form-select-option>
                        </optgroup>
                      </template>
                    </b-select>
                  </b-row>           
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Cancel
                  </b-button>
                  <b-button v-if="!showSaveButton(newItem)" variant="primary" disabled>
                    Save
                  </b-button>
                  <b-button v-else variant="primary" @click="createItem()">
                    Save
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            <b-modal id="modal-import" title="Upload File"  size="lg" header-bg-variant="primary" header-text-variant="light" centered  @close="closeModal()" @hide="closeModal()">
              <div class='modal-body'>
                <b-row v-if="!isHQUser"> 
                  <b-col class="col-lg-4 pt-2">Market:</b-col>
                  <b-select class="col-lg-8" v-model="selectedCountryImport" id="selectedCountryImport">
                    <b-form-select-option :value="null">---</b-form-select-option>
                    <b-form-select-option :value="country.id" v-for="(country,index) in countryList">{{country.description}}</b-form-select-option>
                  </b-select>
                </b-row>
                <br>
                <!-- Form -->
                <form method='post' action='' enctype='multipart/form-data'>
                  <div class='custom-file mb-3'>
                    <input type='file' class="col-lg-8" id='file-input' name='filename' @change="changeFileName()">
                    <label class='custom-file-label' for='file-input'>{{fileName}}</label>
                  </div>
                  <br>
                </form>
              </div>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                   <b-button variant="primary mr-1" @click="exportXlxs(true)"><i class="mdi mdi-file-export"></i>
                    Template
                  </b-button>
                  <b-button variant="secondary" @click="cancel()">
                    Cancel
                  </b-button>
                  <b-button v-if="!showUploadButton()" variant="primary" disabled>
                    Upload
                  </b-button>
                  <b-button v-else variant="primary" @click="uploadFile()">
                    Upload
                  </b-button>
                </fragment>
              </template>
            </b-modal>
            <b-modal id="modal-export" title="Export"  size="sm" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row>
                  <div class="col-sm-4 pt-2">Scope: </div>
                  <b-form-select class="col-sm-8" v-model="selectedScopeExport" :options="options"></b-form-select>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel, ok }" lang="html">
                <fragment><!-- serve semplicemente ad evitare di avere l'errore per cui Vue si lamenta che un template deve avere un solo figlio -->
                  <b-button variant="secondary" @click="cancel()">
                    Cancel
                  </b-button>
                  <b-button variant="primary" @click="exportXlxs(false)">
                    Export Xlsx
                  </b-button>
                </fragment>
              </template>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex";
const FileDownload = require('js-file-download');
import mixin from '../../mixin/mixin.js'
import moment from 'moment'
export default {
  name: 'sol_model',
  mixins: [mixin],
  methods: {
    closeNewModal(){
      this.newItem.model.vetele = null;
      this.isPostInsert = true;
    },
    closeModal(){
      this.fileName = null;
    },
    showUploadButton(){
      if(this.isHQUser) 
        return this.fileName
      else return this.selectedCountryImport && this.fileName;
    },
    goToPriceConf(vetele, idCountry){
      this.setSpinnerStatus(true);
      this.axios
      .post("/ccb/auth/fe/commercialModel/checkIfExistVeteleActive/"+vetele, null, this.authHeader)
      .then(response => {
        if(response.status == 200){
          this.filterObj.idCountry = idCountry; 
          this.setStartFromSolModel(true);
          this.setOriginalSolModelObject({vetele: vetele, isFromPrice : true, selectedCountry: this.selectedCountry, selectedModel: this.selectedModel, filterObjFromPrice : this.filterObj})    
          this.$router.push({name: "price_configurator", params: { vetele : vetele, idCountry: idCountry, filterObj : this.filterObj, from: 'sol_model' }}); 
        }       
      })
      .catch(error => {
        this.$bvModal.msgBoxOk("Model not active", {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      })
      .finally(e=>{
        this.setSpinnerStatus(false);
      })
    },
    toggleElementStatus(item, visibilityValue) {
      var stato = (!visibilityValue) ? 'deactivate' : 'activate'
      this.$bvModal.msgBoxConfirm('Do you want to '+stato+' '+item.model+' ?', {
        title: 'Change Status',
        okVariant: 'danger',
        okTitle: 'Continue',
        cancelTitle: 'Cancel',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        if(value){
          this.saveCurItem(item, visibilityValue);         
        }
      })
    },
    saveCurItem(curItem, visibilityValue) {
      var intLabObj = null;
      if(this.isHQUser){
        intLabObj = {idSolModel: curItem.id.idSol}
      } else {
        intLabObj = {idSolModelMarket: curItem.id.idSolMarket}
      }

      intLabObj.visible = visibilityValue;
      intLabObj.updateDate = new Date();
      if(this.getCurUser.userAliasFromModis)
        intLabObj.updateUser = this.getCurUser.userAliasFromModis;
      else
        intLabObj.updateUser = this.getCurUser.username;
      
      this.setSpinnerStatus(true);
      var id = this.isHQUser ? intLabObj.idSolModel : intLabObj.idSolModelMarket;
      var urlBase = '/ccb/auth/fe/solModel/' + this.isHQUser;     
      this.axios
      .put(urlBase, intLabObj, this.authHeader)
      .then(response => {
        if(response.status == 200) {            
          this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            this.refreshTable();
          })
        }    
      })
      .catch(error => {
      this.$bvModal.msgBoxOk(error.message, {
        okVariant: 'danger',
        hideHeaderClose: false,
        centered: true
      })
      })
      .finally(e=>{
        this.setSpinnerStatus(false);
        this.$bvModal.hide('modal-edit');
      })
    },   
    exportXlxs(isOnlyTemplate){
      this.setSpinnerStatus(true);
      let params = {
        isHQUser: this.isHQUser,
        isOnlyTemplate: isOnlyTemplate,
        scope: this.selectedScopeExport
      }

      this.axios
      .post('/ccb/auth/fe/solModel/toXlsx',  this.filterObj, {
        responseType: 'blob',
        params: params,
        ...this.authHeader})
      .then(response => {
        if(response.status == 200) {            
          this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true,
          })
          var disposition = response.headers['content-disposition'];
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(disposition);
          var filename = matches[1].replace(/['"]/g, '');
          FileDownload(response.data, filename);
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      }).finally(e=>{
        this.setSpinnerStatus(false);
        this.$bvModal.hide('modal-export');
      })
    },
    uploadFile(){
      let file=document.querySelector('#file-input').files[0];   
      let formData = new FormData();
      formData.append("file", file );
      formData.append("filename", file.name );
      formData.append("isHQUser", this.isHQUser);
      if(this.getCurUser.userAliasFromModis)
        formData.append("curUserName", this.getCurUser.userAliasFromModis);
      else
        formData.append("curUserName", this.getCurUser.username);
      if(!this.isHQUser){
        formData.append("idCountry", this.selectedCountryImport);
      }

      formData.append("exampleObj", JSON.stringify(this.filterObj));
       this.setSpinnerStatus(true);
       this.axios
       .post("/ccb/auth/fe/solModel/fromXlsx", formData ,  this.authHeader)
       .then((response) => {
         var result="";
         response.data.forEach(element => {
           result+=element+" \n \n";
         });
           window.datas = result;         
           const messageNodes = this.$createElement(
               'pre',
               {
                 domProps: { innerHTML: result }
               }
             )
           this.$bvModal.msgBoxOk([messageNodes], {
               okVariant: 'success',
               hideHeaderClose: false,
               centered: true,
               size: 'xl'
             }).then(value => {
                this.refreshTable();
              })          
         })
       .catch(error => {
         this.$bvModal.msgBoxOk(error.message, {
           okVariant: 'danger',
           hideHeaderClose: false,
           centered: true
         })
       }).finally(e=>{
         this.setSpinnerStatus(false);
         this.$bvModal.hide('modal-import');
       })
    },
    changeFileName(){
      if(document.querySelector('#file-input').files[0] && document.querySelector('#file-input').files[0].name) {
        this.fileName = document.querySelector('#file-input').files[0].name;
      } else {
        this.fileName = '';
      }

    },
    showSaveButton(item){
      return item.model && item.model.vetele
    },
    customFormatter(date) {
      if(date != null)
        return moment(date).format('DD/MM/YY');
    }, 
    createItem() {
      this.isPostInsert = false;
      var intLabObj = null;
      this.setSpinnerStatus(true);
      if(this.isHQUser){
        intLabObj = this.newItem;
        intLabObj.country = null;
        intLabObj.model = this.newItem.model;
      }else{
        intLabObj = this.newItemMarket;
        intLabObj.country.id = this.newItem.country.id;
        intLabObj.solModel.model.vetele = this.newItem.model.vetele
      }
      if(this.getCurUser.userAliasFromModis)
        intLabObj.insertUser = this.getCurUser.userAliasFromModis;
      else
        intLabObj.insertUser = this.getCurUser.username;
      intLabObj.insertDate = new Date()
      this.axios
      .post('/ccb/auth/fe/solModel/'+ this.isHQUser, intLabObj, this.authHeader)
      .then(response => {
        if(response.status == 200) {
          this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            this.refreshTable();
          })    
          .finally(e=>{
            this.isPostInsert = true;
          })           
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      })
      .finally(e=>{
        this.setSpinnerStatus(false);
        this.$bvModal.hide('modal-new');
      })         
    },
    search() {
      this.setLastSearch(this.search) 
      this.setSpinnerStatus(true);
      var params = {
        page: this.currentPage-1, size: this.perPage, sortBy: this.sortBy, sortDesc: this.sortDesc, isHQUser: this.isHQUser
      }

     /* if(this.isRecuperaSessione && this.$route.params && this.$route.params.filterObjFromPrice) {
          this.filterObj = this.$route.params.filterObjFromPrice;
      } else {
        if(this.selectedCountry)
          this.filterObj.market = this.selectedCountry.codMercato;
        else{
          this.filterObj.market = null;
        }
      }
      */

      this.axios        
        .post('/ccb/auth/fe/solModel/allPaged' , this.filterObj, {
          params: params,
          ...this.authHeader}          
        )
        .then(response => {
          this.items = response.data.content;
          this.totalRowsResult = response.data.totalElements;
          this.setSpinnerStatus(false);       
          this.isRecuperaSessione = false;                      
        });
    },
    getVisibleSol(idSol){
      var sol = this.items.find(item => item.id.idSol == idSol && item.id.idSolMarket == 0);
      if(sol){
        return sol.visible;
      }else{
        return false;
      }
    },
    getAllModel() {
      this.axios
      .post('/ccb/auth/fe/commercialModel/getModelGroup', this.filterObj.countryList, this.authHeader)
      .then(response => {
        if(response.status == 200) {
          this.selectedModel = response.data;
        }
      })
      .catch(error => {
        this.$bvModal.msgBoxOk(error.message, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      })
      .finally(e=>{
        this.setSpinnerStatus(false);
      })         
    },
     recuperaSessione(){
      this.isRecuperaSessione = true;
      if(this.$route.params && this.$route.params.isFromPrice){
          this.filterObj = this.$route.params.filterObjFromPrice;
          if(this.filterObj.idCountry){
            this.selectedCountry = this.countryList.find(country => country.id == this.filterObj.idCountry);
          }
          this.isPostPriceConf = true;
        }else{
          this.isPostPriceConf = false;
        }

        this.selectedModel = this.$route.params.selectedModel;
        this.search();
    },
    refreshTable() {
      this.search();
    },
    ...mapActions([
    'setCurApp',
    'setSpinnerStatus',
    'setLastSearch',
    'setStartFromSolModel',
    'setOriginalSolModelObject'
    ])
  },
  data () {
    return {
      isPostInsert : true,
      selectedCountryImport : null,
      selectedNewAdm : null,
      countryList: [],
      admList : [],
      isPostPriceConf : false,
      filterObj: {
          id : {
            idSolMarket : null,
            idSol: null
          },
          vetele: null,
          adm: null,
          market:null,
          showHq: true,
          showActive: true,
          idCountry: null,
          countryList : []
        },
      selectedModel : null,
      selectedAdm: null,
      selectedCountry : null,
      isHQUser : false,
      selectedScopeExport: true,
      options: [
        { value: true, text: 'ALL' },
        { value: false, text: 'FILTERED' },
      ],
      totalRowsResult: 0,
      routerParams: null,
      currentPage:1,
      perPage:15,
      sortBy:'',
      sortDesc: true,
      curItem: null,
      newItem : {model : {vetele : null}, country : null, visible: true},
      newItemMarket : {solModel : {model : {vetele : null}}, country : {id : null}, visible: false},
      fileName: '',
      items: [],
      fields :  [
        {
          key: 'model',
          label: 'Model',
          sortable: true,
          visible : true
        },
        {
          key: 'adm',
          label: 'ADM',
          sortable: true,
          visible : true
        },
        {
          key: 'market',
          label: 'Market',
          sortable: true,
          visible : true
        },
        {
          key: 'updateDate',
          label: 'Last Update',
          sortable: true,
          visible : true
        },
        {
          key: 'visibleButton',
          label: 'SOL',
          sortable: false,
          visible : true
        },
        {
          key: 'detail',
          label: 'Price Conf',
          sortable: false,
          visible : true
        }
      ],
      isRecuperaSessione: false
    }
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible)
    },
    getContryList() {
      if(!this.isPostPriceConf){
        this.selectedCountry = null;
        this.filterObj.vetele = null;
        this.filterObj.market = null;
        if(this.filterObj.adm){
          var list = this.countryList.filter(country => country.tabele == this.filterObj.adm)
          if(list && list.length > 0){
            return list;
          } else {         
            return [];
          }
        } else {
          return [];
        }
      }else{
        if(this.selectedCountry){
          return new Array(this.selectedCountry);
        }else{
          return [];
        }
      }
    },
    getModelList() {
      if(!this.isPostPriceConf){
        if(this.selectedCountry){
          return ((this.selectedCountry && this.selectedCountry.modelGroupItemList) ? this.selectedCountry.modelGroupItemList : [])
        } else{ 
          if(this.isHQUser){
            return this.selectedModel;
          } else {
            return [];
          }
        }
      }else{
        if(this.filterObj.vetele){
          if(this.selectedModel){
            var modelFind = this.selectedModel.find(models => models.items.find(model=> model.value == this.filterObj.vetele));
            return new Array(modelFind);
          }
          return new Array(this.filterObj.vetele);
        }else{
          return [];
        }
      }
    },
    getContryListInsert() {
      if(this.isPostInsert){
        this.newItem.country = null;
        this.newItem.model.vetele = null;
      }
      if(this.selectedNewAdm){
        var list = this.countryList.filter(country => country.tabele == this.selectedNewAdm)
        if(list && list.length > 0){
          return list;
        } else {         
          return [];
        }
      } else {
        return [];
      }
    },
    getModelListInsert() {
      if(this.isPostInsert){
        this.newItem.model.vetele = null;
      }
      if(this.newItem.country){
        return ((this.newItem.country && this.newItem.country.modelGroupItemList) ? this.newItem.country.modelGroupItemList : [])
      } else{ 
        if(this.isHQUser){
          return this.selectedModel;
        } else {
          return [];
        }
      }
    },
    startFromSolModel(){
      return this.getStartFromSolModel
    },
    ...mapGetters([
      'getCurLanguage',
      'getCurUser',
      'authHeader',
      'getStartFromSolModel',
      'getOriginalSolModelObject'
    ])
  },
  watch:{
    currentPage(newValue,oldValue){
      this.refreshTable();
    },
    perPage(newValue,oldValue){
      this.refreshTable();
    },
    sortBy(newValue,oldValue){
      if(newValue)
        this.refreshTable();
    },
    sortDesc(newValue,oldValue){
      this.refreshTable();
    }
  },
  mounted() {
    var user = this.getCurUser;
    window.scoper=this;
    this.setCurApp('sol_model');
    this.isHQUser = user.isHQUser != null ? user.isHQUser : false;
    if(this.isHQUser){
        this.countryList = ((user && user.countries && user.countries.length) ? user.countries : null);
    }else{
       this.filterObj.showHq = false;
      this.countryList = ((user && user.countries && user.countries.length) ? user.countries.filter(country => country.solEnable) : null);
    }
  
    this.admList = new Set(this.countryList.map(country => country.tabele));   
    this.filterObj.countryList = this.countryList;


    
    this.getAllModel()
    if(this.$route.params && this.$route.params.isFromPrice){      
      this.filterObj.vetele = null;
      this.isPostPriceConf = true;
    }else{
      this.isPostPriceConf = false;
    }
    this.refreshTable();
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
</style>
